export enum ActionLabels {
  Assign = 'Assign',
  Cancel = 'Cancel',
  Confirm = 'Confirm',
  Continue = 'Continue',
  NotifySelected = 'Notify selected',
  Print = 'Print',
  Save = 'Save',
  Okay = 'Okay',
}
